<template>
	<div
		v-for="option in question.options"
		:key="option.uuid"
		class="mb-2"
	>
		<label class="mb-3 has-cursor-pointer block">
			<input
				type="radio"
				:name="question.uuid"
				:value="option.uuid"
				v-model="selectedAnswers"
			/>
			{{ option.text }}
		</label>
		<div v-if="option.image">
			<dynamic-image :image="option.image"></dynamic-image>
		</div>
	</div>
</template>

<script lang="ts">
import DynamicImage from '@/components/ui/hoc/DynamicImage.vue'
import { QuestionItemMixin } from '@/utils/skill-assessment-mixins'
import { defineComponent } from 'vue'

export default defineComponent({
	mixins: [QuestionItemMixin],
	components: {
		DynamicImage
	}
})
</script>

<style scoped>

</style>
